import { useState } from "react";
import { IHU, IReserve } from "../../Interfaces";
import { useHabUnits } from "../../Providers/HabUnit";
import { CloseButton } from "../CloseButton";
import FormReserve from "../FormReserve";
import { GearButton } from "../GearButton";
import ModalElement from "../Modal";
import {
  ButtonsContainer,
  ContainerReserve,
  Date,
  InfosContainer,
  Name,
} from "./style";

interface ICardReserveProps {
  reserve: IReserve;
  HU: IHU;
}

const CardReserve = ({ reserve, HU }: ICardReserveProps) => {
  const [editReserveModalIsOpen, setEditReserveModalIsOpen] =
    useState<boolean>(false);

  const { deleteReserve } = useHabUnits();
  const handleEditModal = () => {
    setEditReserveModalIsOpen(!editReserveModalIsOpen);
  };

  return (
    <ContainerReserve>
      <InfosContainer>
        <Date>{reserve.date}</Date>
        <Name>{reserve.guest.name}</Name>
      </InfosContainer>
      <ButtonsContainer>
        <GearButton showModal={handleEditModal} />
        <CloseButton
          reserveToBeDeleted={reserve}
          deleteReserve={deleteReserve}
          HU={HU}
        />
      </ButtonsContainer>
      <ModalElement
        isOpen={editReserveModalIsOpen}
        closeModal={handleEditModal}
      >
        <FormReserve reserve={reserve} HU={HU} closeModal={handleEditModal} />
      </ModalElement>
    </ContainerReserve>
  );
};

export default CardReserve;
